import { createContext, useContext } from 'react'

export enum SidePanelDisplayStyle {
  Sidebar = 'sidebar',
  Sheet = 'sheet',
}

/** Caller hint: resolve sidebar vs sheet from the viewport, or force sheet. */
export type SidePanelDisplayStylePreference = 'auto' | 'sheet'
export type SidePanelMotion = 'default' | 'smooth'

export enum SidePanelSide {
  Left = 'left',
  Right = 'right',
}

export interface SidePanelContextValue {
  displayStyle: SidePanelDisplayStyle
  open: boolean
  close: () => void
  /**
   * Tell the panel to skip the next outside-click close. Use this from
   * navigation handlers that fire on a click in the main content but should
   * not dismiss the panel (e.g. clicking a row that pushes a detail screen).
   */
  keepOpenOnNextOutsideClick: () => void
}

export const SidePanelContext = createContext<SidePanelContextValue | null>(
  null
)

export function useOptionalSidePanelPresentation(): SidePanelContextValue | null {
  return useContext(SidePanelContext)
}

export function useSidePanelPresentation(): SidePanelContextValue {
  const ctx = useOptionalSidePanelPresentation()
  if (!ctx) {
    throw new Error(
      'useSidePanelPresentation must be used inside a <SidePanel> component'
    )
  }
  return ctx
}
